import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Modal } from "@mantine/core";
import apiService from "../../services/api";

const TrainerPaymentSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);

  useEffect(() => {
    const processPayment = async (): Promise<void> => {
      const trainerId = searchParams.get("trainer_id");
      const paymentSuccess = searchParams.get("payment") === "success";

      // Always show the success modal immediately if payment=success
      // This provides immediate feedback while verification happens in background
      if (paymentSuccess) {
        setShowSuccessModal(true);
        setLoading(false);
      }

      if (!trainerId) {
        console.warn("No trainer_id found in URL");
        return;
      }

      // Verify payment in background (non-blocking)
      try {
        console.log("Verifying trainer registration payment for trainer_id:", trainerId);
        const verifyResponse = (await apiService.verifyTrainerRegistrationPayment({
          trainer_id: trainerId,
        })) as Record<string, unknown>;

        console.log("Trainer payment verification response:", verifyResponse);

        if (verifyResponse.Code !== 200 || verifyResponse.payment_status !== "completed") {
          console.warn("Payment verification returned:", verifyResponse);
          // If verification fails, we still show success since payment likely went through
        }
      } catch (err) {
        console.error("Error verifying trainer payment:", err);
        // Don't change UI on verification error - payment likely succeeded
      }
    };

    processPayment();
  }, [searchParams]);

  const handleClose = (): void => {
    setShowSuccessModal(false);
    // Redirect to home page after closing
    navigate("/");
  };

  if (loading) {
    return (
      <div className="font-sans bg-background min-h-screen flex items-center justify-center p-5">
        <div className="text-foreground text-xl">Processing payment...</div>
      </div>
    );
  }

  return (
    <div className="font-sans bg-background min-h-screen flex items-center justify-center p-5">
      <Modal
        opened={showSuccessModal}
        onClose={handleClose}
        centered
        radius="lg"
        size="md"
        withCloseButton={false}
      >
        <div className="text-center py-4">
          <div className="text-3xl sm:text-5xl mb-5">🐾</div>
          <div className="text-xl sm:text-2xl font-bold mb-8 text-primary">Pheefee</div>
          <div className="text-3xl sm:text-5xl md:text-6xl mb-5 text-success">✅</div>
          <h1 className="text-xl sm:text-2xl font-bold mb-4 text-foreground">
            Payment Successful!
          </h1>
          <p className="text-lg mb-8 text-muted-foreground leading-relaxed">
            Payment successful. We will process your application and get back to you shortly.
          </p>
          <Button onClick={handleClose} radius="md" size="md">
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default TrainerPaymentSuccess;
